import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inline-name-editor" }
const _hoisted_2 = { class: "inline-name-editor-view" }
const _hoisted_3 = ["title", "tabindex"]
const _hoisted_4 = ["placeholder", "aria-invalid", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (!_ctx.editing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(["name-text", { 'is-clickable': _ctx.canEdit }]),
              title: _ctx.$t('global.edit'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNameClick && _ctx.onNameClick(...args))),
              onKeydown: [
                _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onNameClick && _ctx.onNameClick(...args)), ["prevent"]), ["enter"])),
                _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onNameClick && _ctx.onNameClick(...args)), ["prevent"]), ["space"]))
              ],
              tabindex: _ctx.canEdit ? 0 : -1,
              role: "button"
            }, _toDisplayString(_ctx.value || _ctx.placeholder), 43, _hoisted_3),
            (_ctx.canEdit)
              ? (_openBlock(), _createBlock(_component_b_button, {
                  key: 0,
                  size: "is-small",
                  type: "is-text",
                  "icon-left": "pencil",
                  class: "edit-btn",
                  title: _ctx.$t('global.edit'),
                  onClick: _withModifiers(_ctx.beginEdit, ["stop","prevent"]),
                  "aria-label": _ctx.$t('global.edit')
                }, null, 8, ["title", "onClick", "aria-label"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showCopy)
            ? (_openBlock(), _createBlock(_component_CopyToClipboard, {
                key: 0,
                value: _ctx.value || '',
                class: "copy-btn"
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ], 64))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.draft) = $event)),
          placeholder: _ctx.placeholder,
          class: "inline-editor-input name-text",
          onKeydown: [
            _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)), ["prevent"]), ["enter"])),
            _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)), ["prevent"]), ["esc"]))
          ],
          onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
          ref: "inputRef",
          "aria-invalid": !!_ctx.error,
          "aria-label": _ctx.placeholder || _ctx.value
        }, null, 40, _hoisted_4)), [
          [_vModelText, _ctx.draft]
        ])
  ]))
}